import { NgModule } from '@angular/core';
import {
  ActiveCoaState,
  CheckingAccountState,
  CompanyState,
  CostCenterState,
  EconomicGroupState,
  FinancialRecordDetailsState,
  KeychainState,
  UserState,
} from '@celerofinancas/state-management';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsModule } from '@ngxs/store';

/**
 * NGXS store module.
 *
 * Registers the states consumed by the `CoreRegistryInterceptor` bootstrap chain
 * (session, economic group, company, accounts, cost center and keychain) **plus**
 * the ones the screens dispatch afterwards.
 *
 * ## Why FinancialRecordDetailsState matters
 *
 * The "Detalhe do Registro" modal does not fetch the record on its own: it
 * dispatches `LoadFinancialRecordAction`, and the HTTP call is made by the handler
 * inside this state. Without registering the state the dispatch **does not fail**
 * — it simply finds no handler, resolves with no effect, and the component gets
 * `undefined`. The symptom is the modal opening empty and blowing up on
 * `can't access property "amounts"` and `"scheduled_at"`, with no request in the
 * network tab. That was exactly the reported defect — and the hardest one on the
 * screen to diagnose, because there is no DI error and no 404 pointing the way.
 *
 * `ActiveCoaState` comes along: the same modal reads the active chart of accounts
 * to build the entry's category selector.
 */
@NgModule({
  imports: [
    NgxsModule.forRoot(
      [
        UserState,
        EconomicGroupState,
        CompanyState,
        CheckingAccountState,
        CostCenterState,
        KeychainState,
        FinancialRecordDetailsState,
        ActiveCoaState,
      ],
      { developmentMode: false },
    ),
    NgxsReduxDevtoolsPluginModule.forRoot({ disabled: true }),
  ],
})
export class StoreModule {}
